export enum DialogType {
  NORMAL,
  RELOCATION_REPAIR_FIELD,
  RELOCATION_REPAIR_WAREHOUSE,
  BATTERY_REPAIR_FIELD,
  BATTERY_REPAIR_WAREHOUSE,
  CHANGE_TO_REPAIR_FIELD,
  CHANGE_TO_REPAIR_WAREHOUSE,
}

export enum DialogText {
  CANCEL = '취소',
  CONFIRM = '확인',
  COMPLETE = '완료',
  PICKUP = '상차',
  ADD_REPAIR_TYPE_FIELD = '현장 수리 추가',
  ADD_REPAIR_TYPE_WAREHOUSE = '입고 수리 추가',
  RELOCATION_PICKUP = '재배치 상차만 완료',
  COMPLETE_RELOCATION_AND_REPAIR_FIELD = '동일기기의 현장수리도 함께 처리',
  COMPLETE_RELOCATION_AND_REPAIR_WAREHOUSE = '동일기기의 입고수리도 함께 처리',
  COMPLETE_RELOCATION_AND_BATTERY = '동일기기의 배터리도 함께 처리',
  COMPLETE_BATTERY_REPLACEMENT = '배터리 교체만 완료',
  COMPLETE_NOT_FOUND = '찾지 못함 처리 완료',
}

export enum DialogMessage {
  REPAIR_WAREHOUSE_BRING_IN = '<center>입고 완료 하시겠습니까?<br/>거점을 확인해주세요.</center>',
  REPAIR_WAREHOUSE_NO_NEED_REPAIR = '<center>현장 활성화를 진행하시겠습니까?<br/></center>',
  ADD_REPAIR = '<center>수리 유형을 추가 하시겠습니까?</center>',
  COMPLETE_BATTERY_REPLACEMENT = '배터리 교체를 진행하시겠습니까?',
  NOT_FOUND = '바이크를 찾지 못함 처리할까요?',
}

export enum DialogMessageTemplate {
  RELOCATION_PICKUP = '<center>{{ deviceCode }}<br/>재배치 상차 하시겠습니까?</center>',
  QUESTION_CREATE_REPAIR = '<center>선택한 수리 부품: {{ count }}건<br/>수리 부품 확인을 완료하시겠습니까?</center>',
  QUESTION_CHANGE_REPAIR_FIELD = '<center>선택한 수리 부품: {{ count }}건<br/>현장 수리로 변경하시겠습니까?</center>',
  QUESTION_CHANGE_REPAIR_WAREHOUSE = '<center>선택한 수리 부품: {{ count }}건<br/>입고 수리로 변경하시겠습니까?</center>',
  QUESTION_CREATE_REPAIR_FIELD = '<center>선택한 수리 항목: {{ count }}건<br/>현장수리를 추가하시겠습니까?</center>',
  QUESTION_CREATE_REPAIR_WAREHOUSE = '<center>선택한 수리 항목: {{ count }}건<br/>입고수리를 추가하시겠습니까?</center>',
  SHOW_NOT_FOUND_HISTORY = '찾지 못함 처리 내역 보기 {{ count }}',
}

export enum DialogButtonText {
  CANCEL = '취소',
  CONFIRM = '확인',
  COMPLETE = '완료',
  RELOCATION_PICKUP = '재배치 상차',
  ADD_REPAIR_TYPE_FIELD = '현장 수리 추가',
  ADD_REPAIR_TYPE_WAREHOUSE = '입고 수리 추가',
  CREATE_REPAIR_FIELD = '현장수리 추가 완료',
  CREATE_REPAIR_WAREHOUSE = '입고수리 추가 완료',
  COMPLETE_BATTERY_AND_CREATE_REPAIR_FIELD = '현장수리 추가 및 배터리 교체 완료',
  COMPLETE_BATTERY_AND_CREATE_REPAIR_WAREHOUSE = '입고수리 추가 및 배터리 교체 완료',
  COMPLETE_RELOCATION_AND_REPAIR_FIELD = '현장수리 추가 및 재배치 상차 완료',
  COMPLETE_RELOCATION_AND_REPAIR_WAREHOUSE = '입고수리 추가 재배치 상차 완료',
}
